/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { FC, useState } from 'react';
import { Divider, Icon } from 'learning-panel-components';
import { coreService } from 'network-utils';
import LearningPathContent from '@components/learningPath/content/learningPathContent';
import { formatFullTime } from '@components/learningPath/utils';
import LearningPathDetails from '../learningPathDetails/learningPathDetails';
import LearningPathListContent from '../learningPathListContent/learningPathListContent';
import styles from './learningPathOverview.module.scss';

const LearningPathOverview: FC<LearningPathOverviewProps> = (props: LearningPathOverviewProps) => {
    const { learningPathOverview, onClose } = props;
    const [selectedItem, setSelectedItem] = useState<coreService.LearningPathContentType | null>(null);
    const [contentInfo, setContentInfo] = useState<ContentInfo[]>([]);

    const onSelect = (type: coreService.LearningPathContentType) => {
        setSelectedItem(type);
        const updatedEntityTitleAndStatus: ContentInfo[] = [];

        learningPathOverview.itemsByContentType[type].forEach((item: any) => {
            updatedEntityTitleAndStatus.push({
                displayName: item.title,
                url: item.url,
                state: item.state
            });
        });

        setContentInfo(updatedEntityTitleAndStatus);
    };

    const convertObjectToLearningPathContent = () => {
        const typeAndNumber: { [contentType: string]: number } = {};
        const contentTypes = Object.values(coreService.LearningPathContentType) as string[];

        for (const contentType of contentTypes) {
            if (learningPathOverview.itemsByContentType[contentType]) {
                typeAndNumber[contentType] = learningPathOverview.itemsByContentType[contentType].length;
            }
        }

        return typeAndNumber;
    };

    return (
        <div className={styles['learning-path-overview-wrapper']}>
            <div className={styles['learning-path-overview-header']}>
                <div className={styles['learning-path-overview-title']}>{learningPathOverview.name}</div>

                <div
                    className={styles['close-icon']}
                    onClick={e => {
                        e.stopPropagation();
                        onClose();
                    }}
                >
                    <Icon name="exitIcon" />
                </div>
            </div>

            <Divider className={styles.divider} />
            <LearningPathDetails
                score={learningPathOverview.points}
                progress={learningPathOverview.progress}
                duration={formatFullTime(learningPathOverview.duration)}
                certificate
            />
            <Divider className={styles.divider} />
            <LearningPathContent
                typeAndNumber={convertObjectToLearningPathContent()}
                onSelect={onSelect}
                isOpen={selectedItem !== null}
                selectedItem={selectedItem}
            />

            {selectedItem !== null && <LearningPathListContent content={contentInfo} />}
        </div>
    );
};

export interface LearningPathOverviewProps {
    learningPathOverview: coreService.LearningPathOverview;
    onClose: Function;
}

interface ContentInfo {
    displayName: string;
    url: string;
    state: string;
}

export default LearningPathOverview;
